import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoaderService {
    public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public display(value: boolean) {
        this.status.next(value);
    }
}

/**
 * CALLING THE LOADER SERVICE
* constructor(
* 	private loaderService: LoaderService) {
* }
*
* ngOnInit() {
* 	//http call starts
* 	this.loaderService.display(true);
* 	//http call ends
* 	this.loaderService.display(false);
* }

*/



// WEBPACK FOOTER //
// /ng-app/src/core/services/loader.service.ts